export const STATUS = {
  COUNTDOWN: 'countdown',
  DONE: 'done',
  PLAY: 'play',
};



// WEBPACK FOOTER //
// ./src/dots/constants.ts